/**
 * Context set by `<Menu.Portal>` so children know a portal is mounted (and
 * whether it's `keepMounted`). Mirrors React.
 *
 * `createContext<T | null>(null)` + `== null` sentinel.
 */
import { type Accessor, createContext, useContext } from "solid-js";

export const MenuPortalContext = createContext<Accessor<boolean> | null>(null);

/**
 * Optional read — returns false when not inside a Portal.
 */
export function useMenuPortalContext(): Accessor<boolean> {
	const keepMounted = useContext(MenuPortalContext);
	return () => keepMounted?.() ?? false;
}
